/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {fetchAddressAutocompleteResults} from '../api'

export const useMutationFetchAddressAutocompleteResults = createReactQueryMutationHook('fetchAddressAutocompleteResults', fetchAddressAutocompleteResults)
